<div class="modal-header">
  <h4 class="modal-title">Reschedule Interview</h4>
</div>
<div class="modal-body">
  <p class="cancel-text">Are you sure you want to reschedule the interview request from {{companyName}}? If so, please provide your alternative available times below.</p>
  <textarea class="form-control" id="reschedule-text-area" rows="5" [ngClass]="{'error': remaining() < 0}"
  [(ngModel)]="message" maxlength="{{ maxLength }}"></textarea>
  @if (remaining() < 0) {
    <span>{{ remaining() }}</span>
  }
</div>
<div class="modal-footer text-right">
  <button type="button" class="btn btn-cancel" (click)="closeThisDialog()">Cancel</button>
  <button type="submit" class="btn btn-send" [disabled]="!(message.length > 0)"
  (click)="rescheduleInterview()">Send</button>
</div>
